/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
window.Vue = Vue;
import VueRouter from 'vue-router';
Vue.use(VueRouter);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('app', require('./components/ClockApp').default);


// 1. Define route components.
// These can be imported from other files
//const FourOhFourPage = require('./components/pages/404');
const TrackerPage = require('./components/pages/Tracker').default;
const ProjectsPage = require('./components/pages/Projects').default;
const ClientsPage = require('./components/pages/Clients').default;
const ReportsPage = require('./components/pages/Reports').default;
const SettingsPage = require('./components/pages/Settings').default;

import {BModal} from 'bootstrap-vue';
Vue.component('b-modal', BModal);
import {BTable} from 'bootstrap-vue';
Vue.component('b-table', BTable);

const routes = [
    { path: '/', component: TrackerPage },
    { path: '/projects', component: ProjectsPage },
    { path: '/clients', component: ClientsPage },
    { path: '/reports', component: ReportsPage },
    { path: '/settings', component: SettingsPage },
]


const router = new VueRouter({
    routes // short for `routes: routes`
});

if (document.getElementById("app")) {
    const app = new Vue({
        router: router,
        el: '#app',
    });
}
